import { DataCache, QueryResultsRelationship, ForeignKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { BerthClosuresDashboard } from 'data/models/BerthClosuresDashboard';

export class BerthClosuresDashboardCache extends DataCache {
    BerthClosuresDashboards = PCCollection(BerthClosuresDashboard);

    constructor(data : PCCache) {
        super();

        new ForeignKeyRelationship(data.Organizations, this.BerthClosuresDashboards, null, d => d.Organization, d => d.OrganizationId());
        new QueryResultsRelationship(this.BerthClosuresDashboards, data.BerthClosures, d => d.Closures);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/berthclosuresdashboard/cache.ts